import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';

import { ChartsModule } from '@rinminase/ng-charts';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { RecaptchaModule } from 'angular-google-recaptcha';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { ComponentsModule } from './components/components.module';
import { AnimateModule } from './animate/animate.module';

import { FormService } from './services/form.service';

import {
  SwiperModule,
  SWIPER_CONFIG,
  SwiperConfigInterface,
} from 'ngx-swiper-wrapper';
import { PaisComponent } from './pages/pais/pais.component';
import { GraciasComponent } from './pages/gracias/gracias.component';
import { RouterModule } from '@angular/router';

import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  
  direction: 'horizontal',
  slidesPerView: 1.1,
  centeredSlides: true,
  spaceBetween: 10,
  slidesOffsetAfter: 100,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4.1,
      spaceBetween: 20,
      centeredSlides: false,
    },
  },
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
  pagination: true,
};

@NgModule({
  declarations: [AppComponent, HomeComponent, PaisComponent, GraciasComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    ComponentsModule,
    SwiperModule,
    BrowserAnimationsModule,
    AnimateModule,
    ScrollingModule,
    ChartsModule,
    YouTubePlayerModule,
    RouterModule,
    HttpClientModule,
    NgxGoogleAnalyticsModule.forRoot('UA-54212002-4'),
    NgxGoogleAnalyticsRouterModule,
    RecaptchaModule.forRoot({
      siteKey: '6LerO9UZAAAAAKh2sK9hvHuzeyhyynZlBm0Ye_Fs',
    }),
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
    FormService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
